import { Modal } from 'components/Modal';
import { useContext } from 'react';
import { ModalBody } from 'components/Modal/ModalBody';
import { ModalActions } from 'components/Modal/ModalActions';
import { Button } from 'components/Button';
import { RadioGroup } from '@headlessui/react';
import { CheckboxButton } from 'components/CheckboxButton';
import noop from 'lodash/noop';
import { HiringUpdateFlowContext } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateContext';
import { HiringUpdateFlowSteps } from 'features/EmployerHiringUpdateFlow/EmployerHiringUpdateFlow.constants';
import { JobInfo } from 'features/EmployerHiringUpdateFlow/JobInfo';

export const HiredSomeoneStep = () => {
  const { open, step, jobListing, goToNextStep, hiredSomeone, setHiredSomeone } =
    useContext(HiringUpdateFlowContext);

  return (
    <Modal
      size="sm"
      open={open && step === HiringUpdateFlowSteps.HIRED_SOMEONE}
      heading={<span className="text-primary-pure-blue">Did you hire for this role?</span>}
      actionRequired
      onClose={noop}
    >
      <ModalBody>
        {(jobListing?.id || null) && <JobInfo jobListing={jobListing} />}

        <RadioGroup
          className="mt-6 flex flex-col gap-4"
          onChange={setHiredSomeone}
          value={hiredSomeone}
        >
          <RadioGroup.Option value={true}>
            {({ checked }) => (
              <CheckboxButton className="!px-4" singleSelection checked={checked}>
                <div className="ml-2 flex items-center gap-4">
                  <span>👍</span>
                  <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                    Yes, I&apos;ve hired someone
                  </span>
                </div>
              </CheckboxButton>
            )}
          </RadioGroup.Option>

          <RadioGroup.Option value={false}>
            {({ checked }) => (
              <CheckboxButton className="!px-4" singleSelection checked={checked}>
                <div className="ml-2 flex items-center gap-4">
                  <span>⛔</span>
                  <span className="text-sm font-normal text-neutral-dark whitespace-normal">
                    No, I haven&apos;t hired
                  </span>
                </div>
              </CheckboxButton>
            )}
          </RadioGroup.Option>
        </RadioGroup>
      </ModalBody>

      <ModalActions>
        <Button size="lg" fullWidth onClick={goToNextStep} disabled={hiredSomeone === null}>
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
};
